import React from "react";
import { resolveSentimentMarkColor } from "pages/Welcome/welcomeDrawerReviewMeta";

/** Sentiment-colored text marks — read-only parity with dashboard ReviewItem. */
export default function WelcomeDrawerReviewTextHighlight({
  search = [],
  child = "",
  theme = "light",
}) {
  if (!search.length) {
    return child;
  }

  const parts = [];
  let lastIndex = 0;

  search.forEach(({ indices: [startIndex, endIndex], sentiment }) => {
    parts.push(child.slice(lastIndex, startIndex));
    parts.push(
      <mark
        key={startIndex}
        style={{
          backgroundColor: resolveSentimentMarkColor(sentiment),
          color: theme === "dark" ? "white" : "inherit",
          borderRadius: 2,
          padding: "0 1px",
        }}
      >
        {child.slice(startIndex, endIndex + 1)}
      </mark>,
    );
    lastIndex = endIndex + 1;
  });

  parts.push(child.slice(lastIndex));
  return parts;
}
